
define('template!ordersPaymentLinkModalView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="pois">\n    <div class="text">' +
((__t = ( _.i18n('common.orders') )) == null ? '' : __t) +
'</div>\n    <div class="value">' +
((__t = ( pois )) == null ? '' : __t) +
'</div>\n</div>\n<div class="total">\n    <div class="text">' +
((__t = ( _.i18n('common.total') )) == null ? '' : __t) +
'</div>\n    <input type="number" min="0" step="0.01" value="' +
((__t = ( total )) == null ? '' : __t) +
'"/>\n</div>';

}
return __p
};});

